import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import { ChartDoughnut, ChartLine, ChartStackedBar, FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../components/Global";
import PageEight from "./ComponentGroup/PageEight";
import PageFive from "./ComponentGroup/PageFive";
import PageFour from "./ComponentGroup/PageFour";
import PageOne from "./ComponentGroup/PageOne";
import PageSeven from "./ComponentGroup/PageSeven";
import PageSix from "./ComponentGroup/PageSix";
import PageThree from "./ComponentGroup/PageThree";
import PageTwo from "./ComponentGroup/PageTwo";

const Pemetaan = (props) => {
    const request = props.history.location.state.payload;

    require("./Pemetaan.css");
    return (
        <div>
            {/* Page One */}
            <PageOne
                idJadwalCbt={request.idJadwalCbt}
                idKelas={request.idKelas}
                kodeTahunAjaran={request.kodeTahunAjaran}
                kuotaMatematika={request.kuotaMatematika}
                kuotaFisika={request.kuotaFisika}
                kuotaBiologi={request.kuotaBiologi}
                kuotaKimia={request.kuotaKimia}
                kuotaInformatika={request.kuotaInformatika}
                kuotaGeografi={request.kuotaGeografi}
                kuotaSosiologi={request.kuotaSosiologi}
                kuotaEkonomi={request.kuotaEkonomi}
                kuotaAntropologi={request.kuotaAntropologi}
                kuotaBahasaInggris={request.kuotaBahasaInggris}
                kuotaBahasaIndonesia={request.kuotaBahasaIndonesia}
                kuotaBahasaAsing={request.kuotaBahasaAsing}
                kuotaVokasiDanPrakarya={request.kuotaVokasiDanPrakarya}
            />
            {/* Page One */}
            {/* Page Two */}
            {/* <PageTwo /> */}
            {/* Page Two */}
            {/* Page Three */}
            {/* <PageThree /> */}
            {/* Page Three */}
            {/* Page Four */}

            {/* Page Four */}
            {/* Page Five */}
            {/* <PageFour /> */}
            {/* Page Five */}
            {/* Page Six */}
            {/* <PageFive /> */}
            {/* Page Six */}
            {/* Page Seven */}
            {/* <PageSix /> */}
            {/* Page Seven */}
            {/* Page Eight */}
            {/* <PageSeven /> */}
            {/* Page Eight */}
            {/* Page Eight */}
            {/* <PageEight /> */}
            {/* Page Eight */}
            <div style={styles.fixedButton}>
                <button className="buttonPrint" onClick={() => window.print()}>
                    <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} />
                    Print Report
                </button>
            </div>
        </div>
    );
};

export default Pemetaan;

const styles = {
    fixedButton: {
        position: "fixed",
        bottom: "20px",
        right: "0px",
        height: "auto",
        padding: "15px",
        zIndex: 99,
        // -webkit-transform: translate3d(0, 0, 0),
        transition: "all 0.25s ease",
        textAlign: "center",
    },
};
